var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 134,
    viewBox: "0 0 242 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.672 134C154.621 134 144.491 129.815 130.375 119.855L142.698 100.497C152.033 110.748 163.882 112.312 177.228 112.312C201.358 112.312 217.583 92.2594 217.583 65.8996C217.583 39.5397 199.461 22.9525 172.918 22.9525C159.555 22.9525 152.308 24.3046 142.964 34.3726L131.415 16.8993C137.58 8.96135 152.05 -2.87282e-07 172.918 -2.87282e-07C212.275 -2.87282e-07 241.563 27.6412 241.563 65.8996C241.563 104.158 214.846 134 175.672 134Z",
    fill: "#FF7F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 68.0963C0 29.8379 29.2887 2.19675 68.6454 2.19675C89.5177 2.19675 107.457 9.68533 119.356 23.6141L119.239 23.7223C121.839 27.0505 129.32 36.6193 130.792 38.7494C121.732 39.2256 112.648 38.9877 103.625 38.0379L103.788 37.8674C99.4947 33.1185 94.2373 29.3409 88.367 26.7875C82.4967 24.234 76.1487 22.9634 69.7478 23.0608C43.205 23.0608 23.9843 41.7323 23.9843 68.0921C23.9843 94.452 43.205 113.119 69.7478 113.119C76.1161 113.225 82.4329 111.962 88.2715 109.417C94.1101 106.872 99.3346 103.104 103.592 98.3668L103.53 98.3086C107.078 95.3506 113.207 82.4993 113.207 82.4993H70.0141V58.4443H164.162V48.3348L189.648 69.9684L164.162 91.7186V81.7338C164.162 81.7338 149.551 82.724 138.015 82.5035C133.746 93.6168 127.392 103.811 119.293 112.537L119.339 112.583C107.44 126.495 89.5011 134 68.4498 134C29.2887 133.996 0 106.35 0 68.0963Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLogo);
export default __webpack_public_path__ + "static/media/go-logo.617924f1801a29b6976f0bfbab5bdbf9.svg";
export { ForwardRef as ReactComponent };